import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

import { useAuth } from "@/contexts/AuthContext";
import { Logo } from "@/components/Logo";

const AdminLogin = () => {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(email.trim(), password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Dobrodošli natrag");
      navigate("/admin");
    } else {
      toast.error("Prijava neuspješna", { description: res.error });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-emerald-deep grain relative px-6 py-16" data-testid="admin-login-page">
      <div className="relative z-10 w-full max-w-md">
        <div className="flex justify-center mb-10">
          <Logo size="md" />
        </div>

        <div className="border border-gold/20 bg-emerald-darker/70 backdrop-blur-md p-10 md:p-12">
          <div className="flex items-center gap-3 mb-8">
            <Lock className="w-4 h-4 text-gold" strokeWidth={1.5} />
            <span className="font-sans tracking-luxury text-[0.65rem] uppercase text-gold">Admin prijava</span>
          </div>
          <h1 className="font-serif font-light text-3xl md:text-4xl text-[#F5EFE3]" data-testid="admin-login-title">
            Dobrodošli natrag
          </h1>

          <form onSubmit={submit} className="mt-10 space-y-8">
            <div>
              <label className="font-sans tracking-wide-2 text-[0.65rem] uppercase text-gold/80 block mb-2">Email</label>
              <input
                data-testid="admin-email-input"
                className="input-luxury"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@lamaison.hr"
                required
                autoComplete="email"
              />
            </div>
            <div>
              <label className="font-sans tracking-wide-2 text-[0.65rem] uppercase text-gold/80 block mb-2">Lozinka</label>
              <input
                data-testid="admin-password-input"
                className="input-luxury"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                autoComplete="current-password"
              />
            </div>
            <button
              type="submit"
              data-testid="admin-login-btn"
              disabled={submitting}
              className="btn-luxury btn-luxury-solid w-full justify-center disabled:opacity-50"
            >
              {submitting ? (<><Loader2 className="w-4 h-4 animate-spin" /> Prijava…</>) : "Prijavi se"}
            </button>
          </form>
        </div>

        <button onClick={() => navigate("/")} className="block mx-auto mt-8 font-sans tracking-luxury text-[0.65rem] uppercase text-[#B0C4B1] hover:text-gold transition" data-testid="back-home-btn">
          ← Natrag na stranicu
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
